<app-spinner></app-spinner>
<!-- App Route Pages -->
<router-outlet></router-outlet>
